import {Amplify} from 'aws-amplify';
import {ConsoleLogger} from 'aws-amplify/utils';
import {config} from '../config/amplify';
import {stage} from '../config/stage';

// Bootstrap Amplify v6. Imported once for side-effects from main.tsx
// before any provider mounts so `useAuth` / API calls have a configured
// client by the time React renders.
Amplify.configure(config);

ConsoleLogger.LOG_LEVEL = stage === 'ide' ? 'DEBUG' : 'INFO';
